import Image from 'next/image';
import React from 'react';

interface BathIconProps {
  size?: number;
  className?: string;
}

const BathIcon: React.FC<BathIconProps> = ({ size = 24, className = '' }) => {
  return (
    <Image
      src="/images/icons/property-icon-bath.svg"
      alt="Bath icon"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default BathIcon;
